import logoImage from "@/assets/logo.png";
import { Link } from "wouter";

export function DeleteAccountPage() {
  return (
    <div style={{ fontFamily: "system-ui, sans-serif", maxWidth: 680, margin: "0 auto", padding: "32px 20px", color: "#1a1a1a" }}>
      <div style={{ marginBottom: 32 }}>
        <img src={logoImage} alt="CourtVibe" style={{ height: 40, marginBottom: 16 }} />
        <Link href="/" style={{ fontSize: 14, color: "#325e22", textDecoration: "none" }}>
          ← Volver al inicio
        </Link>
      </div>

      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Eliminar cuenta</h1>
      <p style={{ color: "#555", marginBottom: 32 }}>
        Puedes eliminar tu cuenta de CourtVibe en cualquier momento. A continuación
        te explicamos cómo hacerlo y qué ocurre con tus datos.
      </p>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>Cómo eliminar tu cuenta</h2>

        <div style={{ background: "#f6f9f4", border: "1px solid #d4e8c9", borderRadius: 10, padding: 20, marginBottom: 16 }}>
          <p style={{ fontWeight: 600, marginBottom: 8 }}>Desde la app (recomendado)</p>
          <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.8 }}>
            <li>Abre CourtVibe en tu dispositivo.</li>
            <li>Ve a la pestaña <strong>Perfil</strong>.</li>
            <li>Toca el ícono de editar (lápiz) en la esquina superior derecha.</li>
            <li>Selecciona la pestaña <strong>Cuenta</strong>.</li>
            <li>En la sección "Zona de peligro", escribe <strong>ELIMINAR</strong> para confirmar.</li>
            <li>Pulsa <strong>Eliminar mi cuenta</strong>.</li>
          </ol>
          <p style={{ marginTop: 12, fontSize: 14, color: "#555" }}>
            Tu sesión se cerrará inmediatamente y la eliminación es definitiva.
          </p>
        </div>

        <div style={{ background: "#fafafa", border: "1px solid #e5e5e5", borderRadius: 10, padding: 20 }}>
          <p style={{ fontWeight: 600, marginBottom: 8 }}>Por correo electrónico</p>
          <p style={{ margin: 0, lineHeight: 1.7 }}>
            Si no puedes acceder a la app, escríbenos a{" "}
            <a href="mailto:contacto@courtvibe.app" style={{ color: "#325e22" }}>
              contacto@courtvibe.app
            </a>{" "}
            desde la dirección asociada a tu cuenta. Procesaremos la solicitud en un plazo
            máximo de <strong>30 días</strong>.
          </p>
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>Qué ocurre con tus datos</h2>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
          <thead>
            <tr style={{ background: "#f0f0f0" }}>
              <th style={{ textAlign: "left", padding: "8px 12px", borderRadius: "6px 0 0 0" }}>Tipo de dato</th>
              <th style={{ textAlign: "left", padding: "8px 12px", borderRadius: "0 6px 0 0" }}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {[
              ["Nombre, email, foto de perfil", "Eliminados permanentemente"],
              ["Teléfono, fecha de nacimiento, género", "Eliminados permanentemente"],
              ["Historial de partidos y resultados", "Anonimizados como \"Cuenta eliminada\""],
              ["Tokens de sesión y notificaciones push", "Eliminados permanentemente"],
              ["Logros y estadísticas personales", "Eliminados permanentemente"],
            ].map(([tipo, accion], i) => (
              <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "8px 12px" }}>{tipo}</td>
                <td style={{ padding: "8px 12px", color: accion.startsWith("Elim") ? "#c0392b" : "#888" }}>{accion}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ marginTop: 12, fontSize: 13, color: "#777" }}>
          Los partidos se conservan de forma anonimizada para preservar el historial
          de los demás jugadores. Una vez eliminada la cuenta no es posible recuperarla.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>¿Tienes dudas?</h2>
        <p>
          Escríbenos a{" "}
          <a href="mailto:contacto@courtvibe.app" style={{ color: "#325e22" }}>
            contacto@courtvibe.app
          </a>
          . Estaremos encantados de ayudarte.
        </p>
      </section>

      <footer style={{ borderTop: "1px solid #eee", paddingTop: 16, fontSize: 13, color: "#999" }}>
        CourtVibe · Operado por Javier Piña ·{" "}
        <Link href="/privacidad" style={{ color: "#325e22", textDecoration: "none" }}>
          Política de Privacidad
        </Link>{" "}
        ·{" "}
        <Link href="/terminos" style={{ color: "#325e22", textDecoration: "none" }}>
          Términos de Servicio
        </Link>
      </footer>
    </div>
  );
}
